import { useState } from "react";
import { authService } from "../../../services/index.js";

export const useResetPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const resetPassword = async (token, newPassword, confirmPassword) => {
    try {
      setIsLoading(true);
      setError("");
      if (newPassword !== confirmPassword) {
        throw new Error("Passwords do not match");
      }
      setMessage("");
      const response = await authService.resetPassword({
        id: 0,
        resetToken: token,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
      });
      localStorage.clear();
      sessionStorage.clear(); 
      setMessage(response?.message || "Password changed successfully. You can now login.");
      window.location.href = "/login";
    } catch (err) {
      console.log('resetPassword error :>> ', err);
      setError(err?.response?.data?.message || "Failed to change password. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return { resetPassword, isLoading, message, error };
};